import GLightbox from 'glightbox';
import { Modal } from 'bootstrap';

let mapLoaded = false;

// eslint-disable-next-line func-names
const getMapFilterFunction = (filter) => function (obj) {
    return filter.stars.includes(obj.options.stars)
        && filter.cats.filter((value) => obj.options.cats.includes(value)).length > 0;
};

const loadMap = (mapId) => {
    /**
     * @typedef {Object} ymaps
     */
    if (mapLoaded) {
        return;
    }

    const mapContainer = document.getElementById(mapId);
    const filterContainer = document.getElementById('school-filter');
    const mapScript = document.getElementById('ymap-lazy');

    mapLoaded = true;
    // eslint-disable-next-line func-names
    mapScript.onload = function () {
        ymaps.ready(() => {
            const centerCoords = mapContainer.dataset.center
                ? mapContainer.dataset.center.split(',')
                : [55.753215, 37.622504];
            const apiUrl = mapContainer.dataset.url;

            const schoolsMap = new ymaps.Map(mapId, {
                center: centerCoords,
                zoom: 12,
                controls: [],
            });

            schoolsMap.behaviors.disable('scrollZoom');
            schoolsMap.controls.add('zoomControl', {
                size: 'small',
            });
            schoolsMap.controls.add('fullscreenControl');

            const balloonOptions = {
                build() {
                    this.constructor.superclass.build.call(this);

                    this.element = this.getParentElement()
                        .querySelector('.map-balloon');
                    this.onCloseClick = this.onCloseClick.bind(this);

                    this.applyElementOffset();

                    this.element.querySelector('.close')
                        .addEventListener('click', this.onCloseClick);
                },
                clear() {
                    this.element.querySelector('.close')
                        .removeEventListener('click', this.onCloseClick);

                    this.constructor.superclass.clear.call(this);
                },
                onSublayoutSizeChange(...args) {
                    // eslint-disable-next-line no-use-before-define
                    balloonLayoutTemplate.superclass.onSublayoutSizeChange.apply(this, args);

                    if (!this.isElement(this.element)) {
                        return;
                    }

                    this.applyElementOffset();

                    this.events.fire('shapechange');
                },
                applyElementOffset() {
                    const top = -(this.element.offsetHeight + this.element.querySelector('.arrow').offsetHeight);
                    Object.assign(this.element.style, {
                        left: 0,
                        top: `${top}px`,
                    });
                },
                onCloseClick(e) {
                    e.preventDefault();
                    this.events.fire('userclose');
                },
                getShape() {
                    if (!this.isElement(this.element)) {
                        // eslint-disable-next-line no-use-before-define
                        return balloonLayoutTemplate.superclass.getShape.call(this);
                    }

                    const style = getComputedStyle(this.element);
                    const position = {
                        left: parseFloat(style.left),
                        top: parseFloat(style.top),
                    };

                    return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                        [position.left, position.top], [
                            position.left + this.element.offsetWidth,
                            position.top
                            + this.element.offsetHeight
                            + this.element.querySelector('.arrow').offsetHeight,
                        ],
                    ]));
                },
                isElement(element) {
                    return element && element.querySelector('.arrow');
                },
            };
            const balloonLayoutTemplate = ymaps.templateLayoutFactory.createClass([
                '<div class="border-0 shadow map-balloon">',
                '<a class="close" href="#">&times;</a>',
                '<div class="arrow"></div>',
                '$[[options.contentLayout observeSize minWidth=235 maxWidth=300 maxHeight=450]]',
                '</div>',
            ].join(''), balloonOptions);
            const balloonClusterLayout = ymaps.templateLayoutFactory.createClass([
                '<div class="border-0 shadow map-balloon">',
                '<a class="close" href="#">&times;</a>',
                '<div class="arrow"></div>',
                '$[[options.contentLayout observeSize minWidth=235 maxWidth=360 maxHeight=450]]',
                '</div>',
            ].join(''), balloonOptions);
            const balloonContentLayoutTemplate = ymaps.templateLayoutFactory.createClass([
                '<div class="map-balloon-body">',
                '<p class="map-balloon-title mb-2 fs-5 lh-sm">',
                '[if properties.url]<a href="$[properties.url]">$[properties.name]</a>[else]$[properties.name][endif]',
                '</p>',
                '<div class="map-balloon-content">',
                '[if properties.stars]<p class="mb-2">$[properties.stars] <span class="ms-2 text-muted">$[properties.reviews]</span></p>[endif]',
                '   [if properties.phone]<p class="mb-1">$[properties.categories]</p>[endif]',
                '   <p class="mb-1">$[properties.address]</p>',
                '   [if properties.phone]<p class="mb-1">$[properties.phone]</p>[endif]',
                '   [if properties.type=="autodrom"]<p class="mb-1"><span class="badge bg-secondary">автодром</span></p>[endif]',
                '   [if properties.description]<p class="mb-1 mt-2 text-muted lh-sm">$[properties.description]</p>[endif]',
                '   [if properties.hours]<div class="mt-2">$[properties.hours]</div>[endif]',
                '</div>',
                '</div>',
            ].join(''));
            const iconLayoutTemplate = ymaps.templateLayoutFactory.createClass([
                '<div class="map-placemark type-$[properties.type]"></div>',
            ].join(''));

            const objectManager = new ymaps.ObjectManager({
                clusterize: true,
                gridSize: 32,
                clusterIconLayout: 'default#pieChart',
                preset: 'islands#circleIcon',
                clusterIconColor: '#0061DF',
                clusterDisableClickZoom: false,
                clusterOpenBalloonOnClick: true,
                clusterBalloonPanelMaxMapArea: 0,
                clusterBalloonMaxHeight: 450,
                balloonContentLayoutWidth: 300,
                clusterBalloonContentLayout: 'cluster#balloonCarousel',
                clusterBalloonLayout: balloonClusterLayout,
                clusterBalloonItemContentLayout: balloonContentLayoutTemplate,
            });
            objectManager.objects.options.set({
                clusterIconColor: '#0061DF',
                balloonShadow: false,
                balloonLayout: balloonLayoutTemplate,
                balloonContentLayout: balloonContentLayoutTemplate,
                balloonPanelMaxMapArea: 0,
                balloonMaxHeight: 450,
                balloonMinWidth: 235,
                balloonMaxWidth: 300,
                iconLayout: iconLayoutTemplate,
                iconShape: {
                    type: 'Circle',
                    coordinates: [10, 10],
                    radius: 10,
                },
                iconSize: [20, 33],
                iconOffset: [-10, -33],
            });
            schoolsMap.geoObjects.add(objectManager);

            if (filterContainer) {
                const box = filterContainer.getBoundingClientRect();
                const style = getComputedStyle(filterContainer, null);
                schoolsMap.margin.addArea({
                    top: 16,
                    left: box.left + (window.pageXOffset || document.documentElement.scrollLeft),
                    width: parseFloat(style.width.replace('px', '')),
                    height: parseFloat(style.height.replace('px', '')),
                });

                document.querySelectorAll('.school-filter-master')
                    .forEach((master) => {
                        master.addEventListener('click', () => {
                            document.querySelectorAll(`[data-master="${master.id}"]`)
                                .forEach((checkbox) => {
                                    checkbox.checked = master.checked;
                                });
                        });
                    });

                document.querySelectorAll('.school-filter-checkbox')
                    .forEach((checkbox) => {
                        checkbox.addEventListener('click', () => {
                            const filter = {
                                cats: [],
                                stars: [],
                            };

                            document.querySelectorAll('.school-filter-checkbox')
                                .forEach((filterCheckbox) => {
                                    if (filterCheckbox.name !== '' && filterCheckbox.checked) {
                                        filter[filterCheckbox.name].push(parseInt(filterCheckbox.value, 10));
                                    }
                                });

                            Object.keys(filter)
                                .forEach((key) => {
                                    const master = document.querySelector(`#${key}_all`);
                                    const count = document.querySelectorAll(`.school-filter-checkbox[name="${key}"]`).length;

                                    if (filter[key].length === 0) {
                                        master.indeterminate = false;
                                        master.checked = false;
                                    } else if (filter[key].length === count) {
                                        master.indeterminate = false;
                                        master.checked = true;
                                    } else {
                                        master.indeterminate = true;
                                    }
                                });

                            objectManager.setFilter(getMapFilterFunction(filter));
                        });
                    });
            }

            fetch(apiUrl)
                .then((response) => response.json())
                .then((response) => {
                    objectManager.add(response);

                    if (mapContainer.dataset.pan) {
                        if (response.features.length === 1) {
                            schoolsMap.setCenter(response.features[0].geometry.coordinates, 15);
                            schoolsMap.panTo(schoolsMap.getCenter());
                        } else {
                            schoolsMap.setBounds(objectManager.getBounds());
                        }
                    }

                    const mapFilter = mapContainer.closest('#map-toggle')
                        .querySelector('#map-filter-toggle');
                    if (mapFilter) {
                        mapContainer.closest('#map-toggle')
                            .querySelector('#map-filter-toggle')
                            .classList
                            .add('animated', 'tada');
                    }
                    mapContainer.closest('.map-loading')
                        .classList
                        .remove('map-loading');
                });
        });
    };
    mapScript.setAttribute('src', mapScript.getAttribute('data-src'));
    mapScript.removeAttribute('data_src');
};

const checkReviewLength = (control) => {
    if (typeof control !== 'undefined') {
        const textLength = control.value.trim().length;
        const reviewTextTip = control.nextElementSibling;
        const { minLength } = reviewTextTip.dataset;

        reviewTextTip.style.display = 'block';

        if (textLength > minLength) {
            reviewTextTip.innerHTML = 'OK';
            reviewTextTip.classList.remove('text-muted');
            reviewTextTip.classList.add('text-success');
        } else {
            reviewTextTip.innerHTML = `Минимальная длина отзыва - ${minLength} символов. Осталось написать - ${minLength - textLength}`;
            reviewTextTip.classList.remove('text-success');
            reviewTextTip.classList.add('text-muted');
        }
    }
};

document.addEventListener('DOMContentLoaded', () => {
    /**
     * go to review
     */
    if (window.location.hash !== '') {
        const goTo = document.getElementById(window.location.hash.slice(1));
        if (goTo) {
            goTo.classList.add('highlighted');
            goTo.scrollIntoView();
        }
    }

    /**
     * Unauthrozed user review add step 2
     */
    document.addEventListener('review-step-2', () => {
        const signUpModal = document.querySelector('#sign-up-modal');
        const signUpModalInstance = Modal.getOrCreateInstance(signUpModal);

        signUpModalInstance.show();
    });

    document.addEventListener('review-success', (e) => {
        if (e.detail.user.active) {
            window.location = `/review/done/?r=${e.detail.id}`;
        } else {
            window.location = `/review/almost-done/?r=${e.detail.id}`;
        }
    });

    /*
     * Detail lightbox init
     */
    GLightbox({
        selector: '.glightbox',
        zoomable: false,
    });

    /**
     * Expand collapsed detail gallery
     */
    if (document.getElementById('map-filter-toggle')) {
        document.getElementById('map-filter-toggle')
            .addEventListener('click', (e) => {
                e.preventDefault();
                document.getElementById('school-filter')
                    .classList
                    .toggle('collapsed');
                e.currentTarget.blur();
            });
    }

    /**
     * Expand collapsed detail gallery
     */
    if (document.querySelector('.collapsed-gallery-expand')) {
        document.querySelector('.collapsed-gallery-expand')
            .addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector('.collapsed-gallery')
                    .classList
                    .remove('collapsed-gallery');
            });
    }

    /**
     * Expand detail address list
     */
    if (document.querySelector('.address-list-collapse')) {
        document.querySelector('.address-list-collapse')
            .addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector('.address-list')
                    .classList
                    .remove('collapsed');
                e.currentTarget.style.display = 'none';
            });
    }

    /**
     * Switch between map and list
     */
    if (document.querySelector('#map-switch')) {
        document.querySelector('#map-switch')
            .addEventListener('click', () => {
                document.querySelector('#map-toggle')
                    .classList
                    .toggle('map-mode');
                loadMap('map-container');
            });
    }

    /**
     * Expandible opening hours
     */
    document.querySelectorAll('.opening-hours-toggle')
        .forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();

                if (e.currentTarget.classList.contains('collapsed')) {
                    e.currentTarget.classList.remove('collapsed');
                    // eslint-disable-next-line max-len
                    e.currentTarget.nextElementSibling.style.height = `${e.currentTarget.nextElementSibling.scrollHeight}px`;
                } else {
                    e.currentTarget.classList.add('collapsed');
                    e.currentTarget.nextElementSibling.style.height = 0;
                }
            });
        });

    const reviewTextControl = document.querySelector('#review-text');
    if (reviewTextControl) {
        reviewTextControl.addEventListener('keyup', (e) => {
            checkReviewLength(e.target);
        });
    }
});
